import { CardMedia } from "@mui/material";
import defaultImg from "../../img/default-user-avatar.png";

interface ProfileImgProps {
  imgUrl: string | undefined;
  size?: number;
  square?: boolean;
  hideShadow?: boolean;
}

const ProfileImg = ({ imgUrl, size, square, hideShadow }: ProfileImgProps) => {
  let imgStyle = {
    width: size !== undefined ? size : "40px",
    height: size !== undefined ? size : "40px",
    borderRadius: square === true ? "0px" : "200px",
    filter:
      hideShadow === true
        ? "none"
        : "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
    flex: "none",
    order: "0",
    flexGrow: "0",
  };
  let finalUrl = imgUrl;

  return (
    <CardMedia
      style={imgStyle}
      component="img"
      image={finalUrl ? finalUrl : defaultImg}
    />
  );
};

export default ProfileImg;
